angular.module("ainapp")
    .controller("FavouritesController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Favourite Links";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.FavouriteCategories = [];
            MainService.FavouriteCategoryInDropdown().then(function (response) {
                $scope.FavouriteCategories = response.data;
            });

            $scope.Init = function () {

                $scope.PageListArray = $scope.PageList;
                $scope.Pages = [];

                $scope.TokenInfo = AuthenticationService.getTokenInfo();

                $scope.addData = {
                    Category: "",
                    PageName: "",
                    Icon: "",
                    FavouriteCategoryId: "",
                    IsShowQuickLinks: false,
                    Order: 0,
                    Link: "",
                    UserId: $scope.TokenInfo.UserId,
                }


                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.Flinks = [];
                MainService.FavouritesByUser().then(function (response) {
                    $scope.Flinks = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    console.log(err);
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })


                $scope.ViewVal = 0;

            }
            $scope.Init();


            $scope.selectIcon = function (e) {
                $scope.addData.Icon = e.Path;
            }


            $scope.getPages = function () {
                $scope.Pages = [];
                angular.forEach($scope.PageListArray, function (e) {
                    if ($scope.addData.Category == e.Category) {
                        $scope.Pages = e.Pages;
                    }
                })
            }


            $scope.SaveData = function () {

                if ($scope.addData.PageName == "") {
                    toastr.warning("Select Page");
                } else if ($scope.addData.Icon == "") {
                    toastr.warning("Select Icon");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.load = true;

                    angular.forEach($scope.Pages, function (e) {
                        if (e.Name == $scope.addData.PageName) {
                            $scope.addData.Link = e.Link;
                        }
                    })

                    MainService.AddFavourite($scope.addData).then(function (response) {
                        $scope.load = false;
                        if (response) {
                            toastr.success("Success");
                            $scope.Init();
                            $scope.initFinks();
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {

                        toastr.error("Network Error");
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    })
                }


            }

            $scope.edit = function (data) {
                $scope.addData = data;

                angular.forEach($scope.PageListArray, function (aa) {
                    angular.forEach(aa.Pages, function (e) {
                        if (data.PageName == e.Name) {
                            $scope.Pages = aa.Pages;
                            $scope.addData.Category = aa.Category;
                        }
                    })
                })

            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.TokenInfo.IsRemove && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteFavourite($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $scope.Init();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }


      }]);
